import o from"styled-components";import{theme as r}from"../../../theme.js";const n=o.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  width: 1200px;
  @media screen and (max-width: ${r.breakpoints.lg}) {
    width: 100%;
  }
  @media screen and (max-width: ${r.breakpoints.md}) {
    grid-template-columns: 1fr;
    grid-template-rows: max-content 1fr;
    height: 100%;
  }
`,t=o.button`
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  background-color: transparent;
  transition: all .1s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${r.colors.gray[400]}
    }
  }
  &:hover {
    background-color: ${r.colors.gray[200]};
    > svg {
      > g, path {
        fill: ${r.colors.gray[500]};
      }
    }
  }
`,e=o.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${r.spacing*4}px;
  background-color: ${r.colors.primary[500]};
  padding: ${r.spacing*40}px ${r.spacing*8}px;
  > h3, > h1 {
    color: ${r.colors.shades[0]};
    margin: 0;
  }
  > a {
    color: ${r.colors.shades[0]};
    margin-top: ${r.spacing*4}px;
  }
  @media screen and (max-width: ${r.breakpoints.md}) {
    padding: ${r.spacing*8}px;
    > h3, > h1 {
      text-align: center;
    }
    > h3 {
      font-size: 16px;
    }
    > h1 {
      font-size: 20px;
    }
  }
`,i=o.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${r.spacing*4}px;
  height: 100%;
  padding: ${r.spacing*40}px ${r.spacing*8}px;
  box-sizing: border-box;
  > h1, > p {
    margin: 0;
    text-align: center;
  };
  > h1 {
    color: ${r.colors.gray[900]};
  }
  > p {
    color: ${r.colors.gray[500]};
    margin-bottom: ${r.spacing*4}px;
  }
  @media screen and (max-width: ${r.breakpoints.md}) {
    padding: ${r.spacing*8}px;
    height: 100%;
  }
`,a=o.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: unset;
  cursor: pointer;
  &:hover {
    background-color: ${r.colors.gray[100]};
  }
  > svg {
    width: 30px;
    height: 30px;
    transform: rotate(90deg);
    > g, path {
      fill: ${r.colors.gray[300]};
    }
  }
  &.next {
    > svg {
      transform: rotate(-90deg);
    }
  }
`,s=o.div`
  display: flex;
  gap: ${r.spacing*8}px;
`;export{a as ArrowButton,s as ArrowsContainer,t as CloseIconButton,n as Container,i as RatingContainer,e as UserContainer};
